import { Controller } from "@hotwired/stimulus"

export default class ImageSelectorController extends Controller {
  static targets = ["display"]

  display() {
    this.displayTarget.classList.remove("invisible")
  }

  close() {
    this.displayTarget.classList.add("invisible")
  }
}
